/**
 * InputText Label Wrapper Classes
 */

const inputLabelWrapperClasses = '';

/**
 * Blog Theme
 */

const inputTextBlogTheme = {
  inputLabelWrapperThemeClasses: inputLabelWrapperClasses,
};

export default inputTextBlogTheme;
